import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { AccordionEventKey, AccordionSelectCallback } from 'react-bootstrap/esm/AccordionContext'
import PatientAppointmentDetail from './PatientAppointmentDetail'
import { getAppointmentsByPatientId } from '../../../../Adaptor/TUBSIS'
import { GetAppointmentByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'

type Props = { userId: number }

const PatientAppointments: React.FC<Props> = ({ userId }) => {
  const [activeAccordion, setActiveAccordion] = useState<AccordionEventKey | null>(null)

  const [patientAppointments, setPatientAppointments] = useState<GetAppointmentByIdOutput[]>([])
  useEffect(() => {
    if (userId && userId > 0) {

      getAppointmentsByPatientId(userId)
        .then((response) => {

          if (response && response.data) {
            setPatientAppointments(response.data)
          }
        })
        .catch((error) => {
          console.error("Error fetching user:", error);
        });

    }
  }, [userId])

  const toggleAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
    setActiveAccordion(eventKey === activeAccordion ? null : eventKey)
  }

  return (
    <Accordion activeKey={activeAccordion} onSelect={toggleAccordion}>
      <Card key={1}>
        <Card.Header /*style={{backgroundColor:"#FFCDD2"}}*/>
          <div className='d-flex justify-content-between align-items-center w-100'>
            <Button
              className='d-flex justify-content-between align-items-center w-100'
              variant='link'
              onClick={(e) => toggleAccordion('index.toString()', e)}
            >
              <div className='text-left text-gray-700'>RANDEVULAR</div>
            </Button>
          </div>
        </Card.Header>
        <Accordion.Collapse eventKey={'index.toString()'}>
          <Card.Body>
            {patientAppointments && patientAppointments.length > 0 ? (
              <Row className='mb-3'>
                <Form.Group as={Col}>
                  {
                    patientAppointments.map((appointment, index) =>

                      <PatientAppointmentDetail key={index} appointment={appointment} />

                    )
                  }
                </Form.Group>
              </Row>
            ) :
              (<div>
                <div className="d-flex align-items-center">
                  <div className="d-flex justify-content-start flex-column">
                    <span className="text-gray-400 fw-bold text-hover-primary d-block fs-6">RANDEVU BULUNAMADI.</span>
                  </div>
                </div>
              </div>
              )}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  )
}

export default PatientAppointments
